import type { RadarComponentSpec } from "../Processing/types";
import type { DuplicationHandler } from "../widgetContract";

export const radarDuplicate: DuplicationHandler<RadarComponentSpec> = (spec) => {
  for (const s of spec.series) {
    s.queryIds = s.queryIds.map(() => crypto.randomUUID());
  }
};
